import {fromJS, Map} from "immutable";
import React from "react";
import {useState} from "react"
import ArrowDown from "../components/shared/icons/ArrowDown";
import ArrowUp from "../components/shared/icons/ArrowUp";
import "./WithFiltersAndSorting.scss";

export const SORTING_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
}

// const DELAY_BEFORE_UPDATING_FILTER_MS = 3000;


// This helper can be wrapped around a withQuery to provide helpers for the
// table displaying the data.
//
// This tabkes as a second argument two arrays:
// - a tableColumn array defining the title and the id for each column ;
// - a defaultSortings array defining the default sorting for the data.
//
// It provides the withQuery with 2 props:
// - props.filters ;
// - props.sortOrders.
// So the query itself must be updated to have a filter input as well as an
// array of SortingInput.
//
// It also provides the listing component with 3 props for its <Table/>:
// - props.tableColumns (same as the one given to it)
// - props.createFilteringInput, a callback to generate filtering inputs
// - props.createSortingArrows, a callback to generate the sorting arrows
const withFiltersAndSorting = (WrappedComponent, {tableColumns, defaultSortings}) => {
  return function(props) {
    // Filters: Map with column ids as keys
    const [filters, setFilters] = useState(Map());
    // Sortings: Array of objects with a name (column id) and a direction
    const [sortOrders, setSortOrders] = useState(defaultSortings || []);

    const setFilter = (name, value) => {
      const f = filters.set(name, value);
      setFilters(f);
    }
    const currentSortingDirectionForName = (name) => {
      const currentSorting = sortOrders.find(e => e.name === name);
      return currentSorting
        ? currentSorting.direction
        : null;
    }
    const setSorting = (name, newDirection) => {
      setSortOrders([{ name: name, direction: newDirection}]);
    }
    // const toggleSorting = (name) => {
    //   const currentSorting = currentSortingDirectionForName(name);
    //   let newDirection = SORTING_DIRECTIONS.DESC;

    //   if (currentSorting) {
    //     if (currentSorting.direction === SORTING_DIRECTIONS.DESC) {
    //       newDirection = SORTING_DIRECTIONS.ASC;
    //     } else {
    //       newDirection = SORTING_DIRECTIONS.DESC;
    //     }
    //   }

    //   setSorting(name, newDirection);
    // }

    // Helper functions for the table header
    // Filtering input for the given value (cf. tableColumns)
    function createFilteringInput(id) {
      if (!id) {
        return null;
      }

      let timeIdForColumn = 0;
      const handleKey = (event) => {
        // Clear current timer
        window.clearTimeout(timeIdForColumn);

        if (event.key === "Enter") {
          // Update filter (this will trigger a new query to the server)
          setFilter(id, event.target.value);
        } else {
          // Keep the target ref as the event will get binned
          // const target = event.target;
          // timeIdForColumn = window.setTimeout(() => {
          //   setFilter(id, target.value);
          // }, DELAY_BEFORE_UPDATING_FILTER_MS);
        }
      }

      const tipClasses = [
        "tip",
      ];
      
      return (
        <div>
          <input
            type="text"
            onKeyDown={handleKey}
          />
          <div className={tipClasses.join(" ")}>Type Enter to filter</div>
        </div>
      );
    }
    // Sorting arrows for the given value (cf. tableColumns)
    function createSortingArrows(id) {
      if (!id) {
        return null;
      }

      const classes = [
        "tableSortingArrows",
        currentSortingDirectionForName(id),
      ]
      
      return (
        <div className={classes.join(" ")}>
          <ArrowUp color="var(--grey-400)" className="ArrowUp" onClick={() => setSorting(id, SORTING_DIRECTIONS.ASC)} />
          <ArrowDown color="var(--grey-400)" className="ArrowDown" onClick={() => setSorting(id, SORTING_DIRECTIONS.DESC)} />
        </div>
      );
    }

    return (
      // Give the filters and sortOrders to the wrapped component so it can
      // update its query (cf. options in withQuery)
      <WrappedComponent
        filters={filters.filter((f) => f !== "").toJS()} // Don't send empty filters
        sortOrders={sortOrders}
        tableColumns={fromJS(tableColumns(props))}
        createFilteringInput={createFilteringInput}
        createSortingArrows={createSortingArrows}
        {...props}
        />
    );
  }
}


export default withFiltersAndSorting;